/**
 * AzurePickerEndpointChoice — the endpoint radio group for a focused resource
 * that offers alternatives (a SQL Managed Instance whose public data endpoint is
 * enabled: VNet on 1433, or `<mi>.public.<zone>.database.windows.net:3342`).
 * The VNet endpoint stays the default; the public one is a choice, never a
 * silent replacement — "enabled" does not mean reachable from this machine.
 */
import type { AzureDiscoveredResource, AzureManagedInstanceEndpoint } from '../../../types/azureDiscovery';

interface Props {
  resource: AzureDiscoveredResource;
  value: AzureManagedInstanceEndpoint;
  onChange: (value: AzureManagedInstanceEndpoint) => void;
}

export function AzurePickerEndpointChoice({ resource, value, onChange }: Props) {
  const choices = resource.endpointChoices;
  if (!choices || choices.length < 2) return null;
  return (
    <fieldset className="flex flex-wrap items-center gap-x-4 gap-y-1 text-xs" data-testid="azure-picker-endpoint-choice">
      <legend className="sr-only">Endpoint for {resource.name}</legend>
      <span className="text-muted-foreground">Endpoint</span>
      {choices.map((choice) => (
        <label key={choice.id} className="flex items-center gap-1.5">
          <input
            type="radio"
            name={`azure-endpoint-${resource.id}`}
            value={choice.id}
            checked={value === choice.id}
            onChange={() => onChange(choice.id)}
            data-testid={`azure-picker-endpoint-${choice.id}`}
          />
          <span>{choice.label}</span>
        </label>
      ))}
    </fieldset>
  );
}
